import PropTypes from 'prop-types'
import styled from 'styled-components'
import { forwardRef } from 'react'

import { Text, Icon } from '@redriverpress/system'

const Button = styled.button`
  appearance: none;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.gray400};
  border-radius: ${props => props.theme.radii.rounded};
  color: ${props => props.theme.colors.black};
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: ${props => props.theme.space[3]};
  width: 100%;

  &:focus {
    box-shadow: 0 0 0 2px ${props => props.theme.colors.blue500};
  }
`

// When using a component with Dialog.Trigger `asChild`,
// that component needs to be able to forward a ref
const NavModalTrigger = forwardRef(({ label, ...props }, ref) => (
  <Button ref={ref} {...props}>
    <Text as='span' fontWeight={600}>
      {label}
    </Text>
    <Icon ml='auto' pl={3} icon='chevron-down' />
  </Button>
))

NavModalTrigger.displayName = 'NavModalTrigger'

NavModalTrigger.propTypes = {
  label: PropTypes.string.isRequired,
}

export default NavModalTrigger
